export default __webpack_public_path__ + "static/media/rightArrow.dcc34c8d.svg";